var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_9313",
    transform: "translate(0 0.317)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_3981",
    width: 32,
    height: 32,
    transform: "translate(0 -0.317)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_9303",
    transform: "translate(5.903 5.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1545",
    d: "M12,12H31.8V31.8H12Z",
    transform: "translate(-11.963 -11.963)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_9332",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 9332"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1564",
    "data-name": "\\u30D1\\u30B9 1564",
    d: "M30.972,17.952a10.272,10.272,0,0,0-2.129-3.119A10.492,10.492,0,0,0,25.675,12.7a9.951,9.951,0,0,0-7.723,0,10.272,10.272,0,0,0-3.119,2.129A10.492,10.492,0,0,0,12.7,18a9.951,9.951,0,0,0,0,7.723,10.272,10.272,0,0,0,2.129,3.119A10.492,10.492,0,0,0,18,30.972a9.808,9.808,0,0,0,7.723,0,10.272,10.272,0,0,0,3.119-2.129,10.492,10.492,0,0,0,2.129-3.168,9.951,9.951,0,0,0,0-7.723Zm-3.218,9.8a8.331,8.331,0,1,1,0-11.782,8.366,8.366,0,0,1,0,11.782Z",
    transform: "translate(-11.925 -11.925)",
    fill: "#3b4d4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1565",
    "data-name": "\\u30D1\\u30B9 1565",
    d: "M30.94,39.6a1.015,1.015,0,1,0,.743.3,1.015,1.015,0,0,0-.743-.3Z",
    transform: "translate(40.923 45.726) rotate(180)",
    fill: "#3b4d4f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_3999",
    "data-name": "\\u9577\\u65B9\\u5F62 3999",
    width: 1.485,
    height: 7.97,
    transform: "translate(10.727 15.73) rotate(180)",
    fill: "#3b4d4f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsInfo);
export default __webpack_public_path__ + "static/media/icons_info.77909f853f300c7023a6e5b59a4a3cd1.svg";
export { ForwardRef as ReactComponent };